import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import style from './intro-modal.module.scss';
import closeSvg from '../../../../assets/images/gotfl-weena/close-icon.svg';
import { Modal } from 'antd';
import BorderContainer from '../../../../components/border-container/border-container.jsx';
import searchSvg from '../../../../assets/images/gotfl-weena/search-icon.svg';
import { debounce } from '../../../concept-ai/utils/utils.js';
import Intro1 from '../../../../assets/images/trends-dial/intro-1.png';
import Intro2 from '../../../../assets/images/trends-dial/intro-2.png';
import Intro3 from '../../../../assets/images/trends-dial/intro-3.png';
import Intro4 from '../../../../assets/images/trends-dial/intro-4.png';
import Intro1BT from '../../../../assets/images/trends-dial/intro-1-bt.png';
import IntroOut4 from '../../../../assets/images/trends-dial/intro-out-4.png';

const IntroModal = () => {

  const allItemList = [
    {
      img: Intro2,
      imgBt: Intro1BT,
      title: 'Scratch Cooking Evolvement and Recent Trends in Japan',
      date: 'May, 2023',
      context: 'The report includes the evolvement and recent trends of Scratch Cooking in Japan. We collaborated with Mintel to explore the market with the highest levels of innovation and activity in Scratch Cooking (ie the largest number of new product introduction).',
      url: 'https://unilever.sharepoint.com/:b:/s/CMIInnovationteam/Ed3Ib5EWgCdJhsLMYQRmtjoB0P6DeMOci9Tw6MLUVGQRLg?e=sg7L7e'
    },
    {
      img: Intro1,
      imgBt: Intro1BT,
      title: 'Dressings Evolution and Recent Trends in the USA',
      date: 'June, 2024',
      context: 'The report includes the Dressings evolution and recent trends in the USA. We collaborated with Mintel to explore the market with the highest levels of activity in Dressings (ie the largest number of new product introduction).',
      url: 'https://unilever.sharepoint.com/:b:/s/CMIInnovationteam/ESOHm71Og5lMjxh8-tvthK4BDzX0BZvrqnDKOlFxMOb3Yw?e=fIGtj4'
    },
    {
      img: Intro3,
      imgBt: Intro1BT,
      title: 'Mini Meals Evolvement & Recent Trends',
      date: 'April, 2025',
      context: 'The report includes the evolvement and recent trends of Mini Meals across JP, CH, SK, US and UK. We collaborated with Mintel to explore the markets with the highest levels of innovation and activity in Mini Meals (ie the largest number of new product introduction). From key shifts in product development like formats & claims, to evolving consumer behavior around cooking & eating, by leveraging market-specific insights, this analysis provides an actionable framework with recommendations to drive innovation in Mini Meals on a global scale.',
      url: 'https://unilever.sharepoint.com/:p:/r/sites/CMIInnovationteam/_layouts/15/Doc.aspx?sourcedoc=%7B00C04F3B-C013-4BDB-BB95-2AE8DD39399E%7D&file=Mini%20Meals%20Product%20Evolvement%20%26%20Recent%20Trends.pptx&action=edit&mobileredirect=true'
    },
    {
      img: Intro4,
      imgBt: Intro1BT,
      imgOut: IntroOut4,
      title: 'The Foods Trend Dial 2025',
      date: 'April, 2025',
      context: "Consumer behaviours around foods have shifted dramatically. Our refreshed 2025 Foods Trend Dial report uncovers evolutions in what people value, crave, and expect from food. These aren't just buzzwords; they're real changes in how our consumers shop, cook, and eat. In a world still reeling from economic challenges and rapid cultural shifts, consumers are reinventing their habits. Some once-dominant trends are fading or blending into new forms, while bold new behaviours are emerging. It's crucial that we internalise these shifts and align our strategies to meet them.",
      url: 'https://unilever.sharepoint.com/:b:/r/sites/CMIInnovationteam/Shared Documents/General/Trend Dial Update 2025/The Foods Trend Dial 2025.pdf?csf=1&web=1&e=WTl5Si'
    }
  ];
  const [listData, setListData] = useState(allItemList);
  const [currentItem, setCurrentItem] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpen = (item) => {
    setIsModalOpen(true);
    setCurrentItem(item);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const onMore = (item)  => {
    window.open(item.url, '_blank');
  };

  const fnInputChange = useCallback(debounce(function(e) { 
    if (['mayonnaise', 'mayo'].includes(e.target.value.toLowerCase())) {
      setListData([allItemList[1]]);
      return;
    }
    setListData(allItemList.filter(item => item.title.toLowerCase().includes(e.target.value.toLowerCase())));
  }, 500), []);

  return (
    <>
      <div className={style.introPage}>
        <div className={classNames(style.searchWrap)}>
          <div className={classNames(style.searchBox)}>
            <img className={style.searchIcon} src={searchSvg} />
            <input placeholder='Search' onChange={fnInputChange}></input>
          </div>
        </div>
        <div className={style.introItemContainer}>
          {listData.map(item => 
            <div key={item.title} className={style.itemContent} onClick={() => handleOpen(item)}>
              <img src={item.imgOut || item.img} alt="" />
              <div className={style.infoBox}>
                <div className={style.titleBox}>{item.title}</div>
                <div className={style.dateBox}>{item.date}</div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal open={isModalOpen} closeIcon={false} width='1100px' centered footer={false} className={style.customModalWrap}  destroyOnClose={true}>
        <img src={closeSvg} className={classNames(style.closeIcon)} onClick={handleClose} />
        <BorderContainer id="intro_1">
          <div className={classNames(style.contentWrap)}>
            <div className={style.imgBox}>
              <img className={style.imgbg} src={currentItem.img} alt="" />
              <div className={style.infoBox}>
                <div className={style.titleBox}>{currentItem.title}</div>
                <div className={style.dateBox}>{currentItem.date}</div>
                <img className={style.img1} src={currentItem.imgBt} alt="" />
              </div>
            </div>
            <div className={classNames(style.detailWrap)}>
              <div className={classNames(style.title)}>{currentItem?.title}</div>
              <div className={classNames(style.label)}>When :</div>
              <div className={classNames(style.desc)}>{currentItem?.date}</div>
              <div className={classNames(style.label, style.marginTop28)}>Context :</div>
              <div className={classNames(style.scrollBox)}>
                <div className={classNames(style.desc)}>{currentItem?.context}</div>
              </div>
              <div className={classNames(style.btn)} onClick={() => onMore(currentItem)}>More</div>
            </div>
          </div>
        </BorderContainer>
      </Modal>
    </>
  );
};

export default IntroModal;